// QRCodeComponent.js
import React, { useRef } from 'react';
import { QRCodeCanvas } from 'qrcode.react';
import './QRCodeComponent.css'

const QRCodeComponent = ({ url }) => {
    const qrRef = useRef();

    // Function to download the QR code as PNG
    const downloadQRCode = () => {
        const canvas = qrRef.current.querySelector('canvas');
        const pngUrl = canvas
            .toDataURL("image/png")
            .replace("image/png", "image/octet-stream");

        const downloadLink = document.createElement("a");
        downloadLink.href = pngUrl;
        downloadLink.download = "qrcode.png";
        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);
    };

    return (
        <div className="qr-code-container">
            <div ref={qrRef} className="qr-code">
                <QRCodeCanvas value={url} size={128} />
            </div>
            <button className="download-btn" onClick={downloadQRCode}>
                Download QR Code
            </button>
        </div>
    );
};

export default QRCodeComponent;
